function chance(percent) {
  if (Math.random() * 100 <= percent) {
    return true
  }
  return false
}
function random(array) {
  return array[Math.floor(Math.random() * array.length)]
}

export function loadingBabble() {
  let accum = [random(verbs), 'the']
  if (chance(25)) {
    accum.push(random(adverbs))
  }
  accum.push(random(adjectives))
  accum.push(random(nouns))
  if (chance(50)) {
    accum.push(random(sub_nouns))
  }
  const result = accum.join(' ')
  return result[0].toUpperCase() + result.slice(1)
}

const verbs = [
  'attenuating',
  'adjusting',
  'loading',
  'calibrating',
  'rerouting',
  'detecting',
  'resequencing',
  'supercharging'
]
const adverbs = [
  'fore ',
  'aft',
  'starboard',
  'port',
  'central',
  'dorsal',
  'ventral'
]

const adjectives = [
  'transitory',
  'polaron',
  'parabolic',
  'ventral',
  'neogenic',
  'nadion',
  'optronic',
  'higgs',
  'tactical',
  'interphasic',
  'luvetric',
  'thoron',
  'verteron',
  'dermatiraelian',
  'lexorian',
  'ablative',
  'polarity',
  'subspace',
  'electroplasma'
]

const nouns = [
  'decompilers',
  'plate',
  'plasma fluid',
  'distribution',
  'warp core',
  'subspace detectors',
  'transporter',
  'magnetic wave',
  'sensor',
  'resistance',
  'particle',
  'laser',
  'containment field',
  'thrust',
  'vacuum',
  'isotope',
  'navigational',
  'data',
  'conduit',
  'neurotransmitters',
  'gamma ray',
  'subharmonic oscillation',
  'dynoscanner'
]

const sub_nouns = [
  'pattern',
  'polarity',
  'detector',
  'buffer',
  'matrix',
  'sequencer',
  'assembly',
  'housing',
  'chamber',
  'network',
  'bank',
  'thruster'
]
